<div *transloco="let t" class="min-h-dvh 2xl:grid 2xl:grid-cols-[1.15fr_1fr]">
  <!-- ── Dark benefit panel — hidden on mobile ── -->
  <div
    class="hidden 2xl:flex flex-col px-14 py-11"
    style="
      background: radial-gradient(ellipse at 80% 10%, rgba(10, 88, 202, 0.45) 0%, transparent 60%),
        radial-gradient(ellipse at 10% 90%, rgba(0, 151, 254, 0.2) 0%, transparent 55%),
        linear-gradient(180deg, #03133d 0%, #0a1f5c 100%);
    "
  >
    <!-- Header -->
    <header class="flex items-center justify-between mb-16 shrink-0">
      <img src="/images/junoAllWhite-Logo.svg" alt="JunoSign" width="150" height="41" class="h-9 w-auto" />
      <button
        type="button"
        (click)="goBack()"
        class="text-sm font-medium text-white/80 hover:text-white transition-colors cursor-pointer bg-transparent border-none p-0"
      >
        {{ t('INVITE_MEMBERS.BUTTON_BACK') }}
      </button>
    </header>

    <div class="flex flex-col flex-1 justify-center">
      <!-- Step badge -->
      <div class="mb-3.5">
        <span class="inline-flex items-center gap-2 bg-white/10 px-4 py-2 rounded-full">
          <span class="text-xs font-semibold text-stroke-soft tracking-[-0.06px]">{{
            t('INVITE_MEMBERS.STEP_BADGE')
          }}</span>
        </span>
      </div>

      <!-- Hero headline -->
      <div class="mb-8">
        <h2 class="text-[3.875rem] font-bold text-white leading-[1.1] mb-6" style="font-family: 'DM Sans', sans-serif">
          {{ t('INVITE_MEMBERS.HERO_HEADLINE_1') }}
          <em style="font-family: 'Instrument Serif', Georgia, serif; font-style: italic; font-weight: 400">{{
            t('INVITE_MEMBERS.HERO_HEADLINE_2')
          }}</em>
          <br />
          {{ t('INVITE_MEMBERS.HERO_HEADLINE_3') }}
        </h2>
        <p class="text-[1.125rem] text-stroke-soft leading-[1.8]">
          {{ t('INVITE_MEMBERS.HERO_TEXT_1') }}
        </p>
      </div>

      <!-- Benefits -->
      <div class="flex flex-col gap-4 mb-14">
        <!-- Benefit 1 -->
        <div class="flex items-center gap-4">
          <div
            class="flex items-center justify-center h-12 w-12 shrink-0 rounded-lg bg-[rgba(0,151,254,0.15)] border border-[rgba(0,151,254,0.25)]"
          >
            <img src="/images/icons/circle-check-mark.svg" class="h-6 w-6" alt="" />
          </div>
          <div>
            <p class="text-base font-semibold text-white leading-tight">{{ t('INVITE_MEMBERS.BENEFIT_1_TITLE') }}</p>
            <p class="text-sm text-stroke-muted mt-1 leading-[1.4]">{{ t('INVITE_MEMBERS.BENEFIT_1_DESC') }}</p>
          </div>
        </div>
        <!-- Benefit 2 -->
        <div class="flex items-center gap-4">
          <div
            class="flex items-center justify-center h-12 w-12 shrink-0 rounded-lg bg-[rgba(0,151,254,0.15)] border border-[rgba(0,151,254,0.25)]"
          >
            <img src="/images/icons/double-arrow.svg" class="h-6 w-6" alt="" />
          </div>
          <div>
            <p class="text-base font-semibold text-white leading-tight">{{ t('INVITE_MEMBERS.BENEFIT_2_TITLE') }}</p>
            <p class="text-sm text-stroke-muted mt-1 leading-[1.4]">{{ t('INVITE_MEMBERS.BENEFIT_2_DESC') }}</p>
          </div>
        </div>
        <!-- Benefit 3 -->
        <div class="flex items-center gap-4">
          <div
            class="flex items-center justify-center h-12 w-12 shrink-0 rounded-lg bg-[rgba(0,151,254,0.15)] border border-[rgba(0,151,254,0.25)]"
          >
            <img src="/images/icons/person.svg" class="h-6 w-6" alt="" />
          </div>
          <div>
            <p class="text-base font-semibold text-white leading-tight">{{ t('INVITE_MEMBERS.BENEFIT_3_TITLE') }}</p>
            <p class="text-sm text-stroke-muted mt-1 leading-[1.4]">{{ t('INVITE_MEMBERS.BENEFIT_3_DESC') }}</p>
          </div>
        </div>
      </div>

      <!-- Line separator -->
      <div class="border-t border-white/10 mb-6"></div>

      <!-- Trust badges -->
      <div class="flex flex-wrap gap-2 border-white/8">
        @for (badge of trustBadges; track badge) {
        <span
          class="px-2.5 py-1 border border-ink-muted rounded-lg text-[0.65625rem] font-bold text-ink-subtle tracking-[0.84px]"
        >
          {{ badge }}
        </span>
        }
      </div>
    </div>
  </div>

  <!-- ── Form column ── -->
  <div class="bg-[#f0f4fb] 2xl:bg-white flex flex-col min-h-dvh 2xl:min-h-0">
    <!-- Mobile/tablet header -->
    <header class="2xl:hidden flex items-center justify-between px-6 md:px-10 py-5">
      <img
        src="/images/juno-Black-Blue-Logo.svg"
        alt="JunoSign"
        width="140"
        height="38"
        class="h-8 w-auto object-contain"
      />
      <button
        type="button"
        (click)="goBack()"
        class="text-sm font-medium text-ink-muted hover:text-ink transition-colors cursor-pointer bg-transparent border-none p-0"
      >
        {{ t('INVITE_MEMBERS.BUTTON_BACK') }}
      </button>
    </header>

    <div class="flex flex-col flex-1 justify-start sm:justify-center py-6 sm:py-12 px-6 md:px-10 2xl:px-14">
      <div
        class="w-full max-w-md mx-auto 2xl:mx-0 2xl:max-w-none bg-white 2xl:bg-transparent rounded-2xl 2xl:rounded-none shadow-[0_4px_24px_rgba(3,19,61,0.08)] 2xl:shadow-none border border-[#e8eef8] 2xl:border-0 p-7 sm:p-8 2xl:p-0"
      >
        <!-- Users group icon -->
        <div class="mb-7">
          <div
            class="flex items-center justify-center w-18 h-18 rounded-[1.125rem] border border-[#c4d9fc] shrink-0"
            style="background: linear-gradient(135deg, #eff4ff 0%, #dce9ff 100%)"
          >
            <img src="/images/icons/users-group.svg" class="h-9 w-9" alt="" />
          </div>
        </div>

        <!-- Form heading -->
        <div class="mb-6">
          <p class="text-xs font-bold text-primary tracking-[0.96px] mb-3">
            {{ t('INVITE_MEMBERS.FORM_EYEBROW') }}
          </p>
          <h1
            class="text-[1.75rem] sm:text-[2rem] font-bold text-ink leading-[1.15] mb-2.5"
            style="font-family: 'DM Sans', sans-serif"
          >
            {{ t('INVITE_MEMBERS.INVITE_YOUR_TEAMMATES') }}
          </h1>
          <p class="text-base text-ink-muted leading-[1.4]">
            {{ t('INVITE_MEMBERS.FORM_SUBHEADING') }}
          </p>
        </div>

        <!-- Form -->
        <form [formRoot]="membersForm">
          <div class="flex flex-col gap-6">
            <!-- Invite rows -->
            <div class="flex flex-col gap-3">
              @for (member of membersForm.members; track $index) {
              <div class="flex gap-2 items-start">
                <juno-libs-ui-input
                  class="flex-1 min-w-0"
                  [formField]="member.email"
                  type="email"
                  labelClass="hidden"
                  [placeholder]="'INVITE_MEMBERS.EMAIL_PLACEHOLDER'"
                />

                <!-- Role select: hidden on mobile -->
                <juno-libs-ui-select
                  class="hidden sm:block shrink-0 min-w-[6.4rem]"
                  [formField]="member.role"
                  labelClass="hidden"
                  [options]="roles"
                />

                <!-- Remove button -->
                <button
                  type="button"
                  (click)="removeMember($index)"
                  [disabled]="isOnlyOneMemberLeft()"
                  class="group flex items-center pt-3.25 justify-center h-7 w-7 shrink-0 rounded-full hover:bg-surface-subtle disabled:opacity-30 disabled:cursor-not-allowed transition-colors bg-transparent border-none cursor-pointer mt-1"
                  aria-label="Remove"
                >
                  <img
                    src="/images/icons/modal-close-icon.svg"
                    class="h-4 w-4 transition-all group-hover:brightness-75"
                    alt=""
                  />
                </button>
              </div>
              }
            </div>

            <!-- Add another button -->
            <button
              type="button"
              data-test-id="addMember"
              (click)="addNewMember()"
              [disabled]="hasEmptyFields()"
              class="flex items-center justify-center gap-2 w-full px-4 py-3 border-[1.5px] border-dashed border-[#d6e0f5] rounded-lg text-sm font-semibold text-primary hover:bg-primary-tint disabled:opacity-50 disabled:cursor-not-allowed transition-colors bg-transparent cursor-pointer"
            >
              <img src="/images/icons/user-plus.svg" class="h-5 w-5" alt="" />
              {{ t('INVITE_MEMBERS.ADD_ANOTHER') }}
            </button>

            <!-- Billing note -->
            <div class="flex gap-2.5 items-start bg-surface-card border border-stroke-soft rounded-[10px] px-3.5 py-3">
              <img src="/images/icons/info-circle.svg" class="h-4 w-4 shrink-0 mt-0.5" alt="" />
              <p class="text-xs text-ink-secondary leading-normal">
                {{ t('INVITE_MEMBERS.BILLING_NOTE') }}
              </p>
            </div>

            <!-- CTA row -->
            <div class="flex flex-col-reverse sm:flex-row gap-4">
              <dss-libs-ui-button
                class="w-full"
                type="button"
                color="gray"
                variant="outline"
                label="INVITE_MEMBERS.BUTTON_SKIP"
                appliedClasses="w-full! sm:flex-1! h-12!"
                (clickOutput)="skipInvitingMembers()"
              />
              <dss-libs-ui-button
                class="w-full"
                type="submit"
                color="primary"
                variant="fill"
                label="INVITE_MEMBERS.SEND_INVITES"
                [disabled]="isSubmitDisabled()"
                appliedClasses="w-full! sm:flex-1! h-12!"
              />
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Payment plans modal trigger (rendered as overlay) -->
    <dss-libs-feature-payment-plans [planId]="planId()"></dss-libs-feature-payment-plans>
  </div>
</div>
